import { render, staticRenderFns } from "./SetOfCriteriaSave.vue?vue&type=template&id=f1379d82&"
import script from "./SetOfCriteriaSave.vue?vue&type=script&lang=js&"
export * from "./SetOfCriteriaSave.vue?vue&type=script&lang=js&"
import style0 from "./SetOfCriteriaSave.vue?vue&type=style&index=0&id=f1379d82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports